import { render, staticRenderFns } from "./PageSizeSelect.vue?vue&type=template&id=746933a4&scoped=true"
import script from "./PageSizeSelect.vue?vue&type=script&lang=js"
export * from "./PageSizeSelect.vue?vue&type=script&lang=js"
import style0 from "./PageSizeSelect.vue?vue&type=style&index=0&id=746933a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746933a4",
  null
  
)

export default component.exports